import React from 'react';
import { Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { createBrowserHistory } from 'history';
import PropTypes from 'prop-types';

import theme from './theme';
import './App.scss';
import Routes from './Routes';
import withSession from './components/Session';

const history = createBrowserHistory();

const App = ({ session, refetch }) => {
  return (
    <ThemeProvider theme={theme}>
      <Router history={history}>
        <Routes session={session} refetch={refetch} />
      </Router>
    </ThemeProvider>
  );
};
App.propTypes = {
  session: PropTypes.any.isRequired,
  refetch: PropTypes.any.isRequired,
};

export default withSession(App);
